module.exports = __webpack_public_path__ + "img/budget-bg.fd1a8152.png";